import { render, staticRenderFns } from "./Accessi_stat.vue?vue&type=template&id=3f4953e9&"
import script from "./Accessi_stat.vue?vue&type=script&lang=js&"
export * from "./Accessi_stat.vue?vue&type=script&lang=js&"
import style0 from "./Accessi_stat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
